(function () {
  function removeAddPrefix() {
    const containers = document.querySelectorAll('[data-child-name*="construction"][data-child-type="upsell"], [data-child-name="Contruction - Split"][data-child-type="upsell"], [data-child-name="Function"][data-child-type="upsell"], [data-child-name="Width"][data-child-type="upsell"]');

    containers.forEach(container => {
      const titles = container.querySelectorAll('.gs__checkbox-input-title');

      titles.forEach(title => {
        // Get only the text node before <small>
        const firstNode = title.childNodes[0];

        if (firstNode && firstNode.textContent === "Add") {
          firstNode.textContent = "";
        }

      });
    });
  }

  // Run immediately
  removeAddPrefix();

  // Optional: re-run if content is dynamically injected (Giftship often does this)

  document.addEventListener('giftship.loaded', function() {
    const currentPage = window.GSSDK.page.get();
    setTimeout(removeAddPrefix, 1);
  });

})();

/*
 * Keep Giftship's Artwork Selection in sync with the Motion product gallery.
 *
 * Giftship renders the selected artwork name as data-child-option-name. The
 * matching Shopify product image includes that artwork name in its filename.
 * Activating Motion's existing thumbnail keeps the main image, mobile slider,
 * thumbnail state, and image viewer synchronized without replacing image URLs.
 */
(function () {
    const artworkSelector = '[data-child-name="Artwork Selection"]';
    const artworkInputSelector = 'input[data-child-option]';
    const snowsportProductSelector =
        '[data-section-type="product"][data-kindred-snowsport-product="true"]';
    const productThumbSelector = '[data-product-thumb]';

    function normalize(value) {
        return String(value || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/&/g, ' and ')
            .replace(/[^a-z0-9]+/g, ' ')
            .trim();
    }

    function getArtworkNames(input) {
        const artworkName = normalize(
            input.dataset.childOptionName ||
            input.dataset.childOptionValue ||
            input.value
        );

        /*
         * Splitboard media uses "race-black" and "race-white", while the
         * corresponding Giftship choices include the word "Graphic".
         */
        const artworkNameWithoutGraphic = artworkName
            .replace(/\bgraphic\b/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();

        return Array.from(new Set([
            artworkName,
            artworkNameWithoutGraphic
        ].filter(Boolean)));
    }

    function getThumbnailFilename(thumbnail) {
        let href = thumbnail.getAttribute('href') || '';

        try {
            href = decodeURIComponent(href);
        } catch (error) {
            // Keep the original URL if it contains malformed escape sequences.
        }

        const filename = href.split('?')[0].split('/').pop() || href;

        return normalize(filename);
    }

    function getSnowsportProductSection(input) {
        const productSection = input.closest(
            '[data-section-type="product"]'
        );

        if (
            !productSection ||
            !productSection.matches(snowsportProductSelector)
        ) {
            return null;
        }

        return productSection;
    }

    function activateArtworkImage(input) {
        if (!input || !input.checked) {
            return;
        }

        const productSection = getSnowsportProductSection(input);
        const artworkNames = getArtworkNames(input);

        if (!productSection || !artworkNames.length) {
            return;
        }

        const matchingThumbnail = Array.from(
            productSection.querySelectorAll(productThumbSelector)
        ).find(function (thumbnail) {
            const thumbnailFilename = getThumbnailFilename(thumbnail);

            return artworkNames.some(function (artworkName) {
                return thumbnailFilename.includes(artworkName);
            });
        });

        /*
         * Some products do not have every Giftship artwork in their Shopify
         * media gallery. Leave the current image unchanged when no
         * corresponding product media exists.
         */
        if (!matchingThumbnail) {
            return;
        }

        if (!matchingThumbnail.classList.contains('is-active')) {
            matchingThumbnail.click();
        }
    }

    function syncSelectedArtwork(artworkContainer) {
        if (!artworkContainer) {
            return;
        }

        activateArtworkImage(
            artworkContainer.querySelector(
                `${artworkInputSelector}:checked`
            )
        );
    }

    function syncAllSelectedArtwork() {
        document.querySelectorAll(artworkSelector).forEach(
            syncSelectedArtwork
        );
    }

    document.addEventListener('change', function (event) {
        if (
            !event.target.matches(
                `${artworkSelector} ${artworkInputSelector}`
            )
        ) {
            return;
        }

        activateArtworkImage(event.target);
    });

    document.addEventListener('giftship.loaded', function () {
        setTimeout(syncAllSelectedArtwork, 1);
    });

    document.addEventListener('giftship.reloaded', function () {
        setTimeout(syncAllSelectedArtwork, 1);
    });
})();
(function () {
    const artworkSelector = '[data-child-name="Artwork Selection"]';
    const optionSelector = '.gs__checkbox-container';
    const imageSelector = '.gs__custom-checkbox';

    const isTouchDevice = window.matchMedia(
        '(hover: none), (pointer: coarse)'
    ).matches;

    const tooltip = document.createElement('div');

    tooltip.style.cssText = `
        position: absolute;
        z-index: 999999;
        padding: 6px 10px;
        background: #000;
        color: #fff;
        font-size: 13px;
        line-height: 1.2;
        border-radius: 4px;
        pointer-events: none;
        display: none;
        white-space: nowrap;
        left: 50%;
        top: 50%;
        margin-top: 6px;
        transform: translateX(-50%) translateY(-50%);
    `;

    function getArtworkOption(target) {
        return target.closest(
            `${artworkSelector} ${optionSelector}`
        );
    }

    function prepareContainer(container) {
        /*
         * Find the actual Artwork Selection wrapper from the
         * option being interacted with.
         */
        const artworkContainer = container.closest(artworkSelector);

        if (!artworkContainer) {
            return;
        }

        /*
         * Find the actual fieldset at interaction time.
         * This works even if Giftship rendered everything after
         * this script originally executed.
         */
        const fieldset = container.closest('fieldset');

        if (fieldset) {
            fieldset.style.setProperty(
                'overflow',
                'visible',
                'important'
            );
        }

        /*
         * Open any intermediate wrappers that could also clip
         * the absolutely positioned tooltip.
         */
        let parent = container.parentElement;

        while (
            parent &&
            parent !== artworkContainer.parentElement
        ) {
            parent.style.setProperty(
                'overflow',
                'visible',
                'important'
            );

            parent = parent.parentElement;
        }

        /*
         * Tooltip is positioned relative to the individual option.
         */
        container.style.setProperty(
            'position',
            'relative',
            'important'
        );
    }

    function showTooltip(container) {
        const input = container.querySelector(
            'input[data-child-option-name]'
        );

        if (!input) {
            return;
        }

        prepareContainer(container);

        container.appendChild(tooltip);

        tooltip.textContent = input.dataset.childOptionName;
        tooltip.style.display = 'block';
    }

    function hideTooltip() {
        tooltip.style.display = 'none';
    }

    function updateSelectedImages() {
        document
            .querySelectorAll(artworkSelector)
            .forEach(function (artworkContainer) {
                const inputs = artworkContainer.querySelectorAll(
                    'input[data-child-option]'
                );

                const selected = artworkContainer.querySelector(
                    'input[data-child-option]:checked'
                );

                inputs.forEach(function (input) {
                    const container = input.closest(optionSelector);

                    if (!container) {
                        return;
                    }

                    const image = container.querySelector(imageSelector);

                    if (!image) {
                        return;
                    }

                    image.style.transition = 'opacity 0.2s ease';

                    if (!selected || input.checked) {
                        image.style.opacity = '1';
                    } else {
                        image.style.opacity = '0.45';
                    }
                });
            });
    }

    /*
     * Selection opacity.
     */
    document.addEventListener('change', function (event) {
        if (
            !event.target.matches(
                `${artworkSelector} input[data-child-option]`
            )
        ) {
            return;
        }

        updateSelectedImages();
    });

    if (isTouchDevice) {
        document.addEventListener(
            'touchstart',
            function (event) {
                const container = getArtworkOption(event.target);

                if (!container) {
                    return;
                }

                showTooltip(container);
            },
            { passive: true }
        );
    } else {
        document.addEventListener('mouseover', function (event) {
            const container = getArtworkOption(event.target);

            if (!container) {
                return;
            }

            showTooltip(container);
        });

        document.addEventListener('mouseout', function (event) {
            const container = getArtworkOption(event.target);

            if (!container) {
                return;
            }

            if (
                event.relatedTarget &&
                container.contains(event.relatedTarget)
            ) {
                return;
            }

            hideTooltip();
        });
    }

    /*
     * Also catches pre-selected options once the user interacts
     * with the page, even if Giftship rendered after this script.
     */
    document.addEventListener(
        'pointerdown',
        function () {
            updateSelectedImages();
        },
        { once: true }
    );
})();
